module.exports = __webpack_public_path__ + "img/line.1ada84f.svg";